// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"start-step_wrapper__1gwuJ","text":"start-step_text__ABoYV","panel":"start-step_panel__2eXpy"};